/** @format */

import {HotspotKey, HotspotStatusList} from '../../../types';

const getFilteredKeys = (statusList: HotspotStatusList): HotspotKey[] => {
  const keys = Object.keys(statusList) as HotspotKey[];

  return keys.filter(key => {
    const {isReady, isDisplay} = statusList[key];
    return isReady || !isDisplay;
  });
};

export {getFilteredKeys};
